import './scss/main.scss'
import './scss/message.scss'

import shelltool from './js/shelltool'
import parseWxEmo from './js/parseWxEmo'
import content from './js/content'
import utils from './js/utils';

const initApp = () => {
    
    // Sentry.init({
    //   dsn: "https://adbce50847f8499e9c168d880af79568@sentry.weiyoubot.cn/8",
    //   integrations: [new Sentry.Integrations.BrowserTracing()],
      
    //   // Set tracesSampleRate to 1.0 to capture 100%
    //   // of transactions for performance monitoring.
    //   // We recommend adjusting this value in production
    //   tracesSampleRate: 1.0,
    // });

    window.winData = {sendWs: () => {}, resetTimeWs: 0};
    shelltool.init();
    
    var currentRef = document.referrer;
    //判断 1、访问网页的来源是包含public域名的
    if(currentRef.indexOf('zhiniplugin.h5bqb.top') > 0){ 
      setTimeout(() =>{
        let channel_id = utils.getParameterByName("channel_id");
        window.location.href = `https://zhinikefu.com/?hmsr=wangyechajian&hmpl=illegal&channel_id=${channel_id}`;
      },2000)
    }else{
      let isHide = utils.getParameterByName("isHide");
      if(isHide) {
        return;
      }
      content.startProcess();
      window.addEventListener('message', function (event) {
        var data = event.data;
        switch (data.type) {
            case 'ping': {
                break;
            }
            default:
                break;
        }
      }, false);
    }

};
initApp();



// WEBPACK FOOTER //
// ./src/index.js